export default __webpack_public_path__ + "static/media/novlogo.3ccc91bb.png";